import { env } from '@/lib/env'

/**
 * Base da API sem sufixo /api (igual ao data-api-url do widget).
 */
export function widgetApiBaseUrl(): string {
  if (env.configuredApiBaseUrl) return env.configuredApiBaseUrl
  if (env.apiBaseUrl) return env.apiBaseUrl
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  return ''
}

/**
 * Normaliza cor hexadecimal para uso no snippet e nas prévias (sempre #rrggbb minúsculo).
 */
export function normalizeHex6(value: string, fallback: string): string {
  const trimmed = value.trim()
  if (!trimmed) return fallback

  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`

  const six = /^#([0-9a-fA-F]{6})$/.exec(withHash)
  if (six) return `#${six[1].toLowerCase()}`

  const three = /^#([0-9a-fA-F]{3})$/.exec(withHash)
  if (three) {
    const [r, g, b] = three[1].toLowerCase().split('')
    return `#${r}${r}${g}${g}${b}${b}`
  }

  return fallback
}

/**
 * Retorna #rrggbb se o rascunho já é um hex completo (3 ou 6 dígitos); caso contrário null.
 */
export function tryParseCompleteHex(value: string): string | null {
  const trimmed = value.trim()
  if (!trimmed) return null

  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`

  const six = /^#([0-9a-fA-F]{6})$/.exec(withHash)
  if (six) return `#${six[1].toLowerCase()}`

  const three = /^#([0-9a-fA-F]{3})$/.exec(withHash)
  if (three) {
    const [r, g, b] = three[1].toLowerCase().split('')
    return `#${r}${r}${g}${g}${b}${b}`
  }

  return null
}

/**
 * Hex para prévia e snippet em tempo real: usa o digitado quando já é válido; senão a cor confirmada no seletor.
 */
export function previewHexForLiveDisplay(draft: string, committed: string, fallback: string): string {
  const parsed = tryParseCompleteHex(draft)
  if (parsed) return parsed
  return normalizeHex6(committed, fallback)
}

export function clampWidgetRadiusPx(raw: string, fallback: number): number {
  const n = Number.parseInt(raw, 10)
  if (!Number.isFinite(n)) return fallback
  return Math.min(50, Math.max(0, n))
}

/** Escapa texto para uso seguro em atributos HTML entre aspas duplas. */
export function escapeHtmlAttribute(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
}
